import { useUserContext } from '@/auth/UserContext';
import { ProfileStatus, type UserInfoResponse } from '@/types/user';

const getProfileStatus = (
  user: UserInfoResponse | undefined,
): ProfileStatus | null => {
  const studyYear = user?.studyYear;

  if (!studyYear) {
    return null;
  }

  if (studyYear.isNext) {
    return ProfileStatus.NextStudyYear;
  }

  if (!studyYear.isCurrent) {
    return ProfileStatus.PastStudyYear;
  }

  if (user.class && !user.class.isCurrent) {
    return ProfileStatus.InactiveProfile;
  }

  return null;
};

export const useProfileStatus = (): ProfileStatus | null => {
  const { user } = useUserContext();

  return getProfileStatus(user);
};
